import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import Axios from "./../../apiConfig/Axios";
import apiRoutes from "services/apiRoutes";

//////////////////////////////////////logout//////////////////////////
const fetchLogoutFn = async (data: reqLogoutType) => {
    const res = await Axios.post<
      GlobalApiResponseType<string>
    >(apiRoutes.logout.Post,
       data,
	   {
		params: {
			pt: data.pt
		}
	  }
	);
    return res.data;
  };
  
  export const useLogout = (
    option?: Omit<
      UseMutationOptions<
        GlobalApiResponseType<string>,
        Error,
        reqLogoutType
      >,
      "mutationKey" | "mutationFn"
    >
  ) => {
    return useMutation<
      GlobalApiResponseType<string>,
      Error,
      reqLogoutType
    >(fetchLogoutFn, option);
  };